import React from 'react'
import styles from './Loading.module.scss'
import { useWording } from '../../hooks/useWording'
import classNames from 'classnames'

interface LoadingProps {
    message?: string
    size?: 'small' | 'medium' | 'large'
}

export const Loading: React.FC<LoadingProps> = ({ 
    message, 
    size = 'medium' 
}) => {
    const wording = useWording()
    const loadingMessage = message || wording?.loading || 'Loading...'

    return (
        <div className={styles.loadingContainer}>
            <div className={classNames(styles.spinner, styles[size])}></div>
            <p className={styles.message}>{loadingMessage}</p>
        </div>
    )
} 